import { Text, HStack } from '@genial/components';
import React from 'react';

import { InfoTooltip } from '../../../InfoTooltip';

export interface CustomerDuckLabelProps {
  label?: string;
  labelTooltip?: string;
  opaque?: boolean;
}

export const CustomerDuckLabel: React.FC<CustomerDuckLabelProps> = ({
  label,
  labelTooltip,
  opaque,
}) => {
  if (!label) {
    return null;
  }

  return (
    <HStack space="inline.quarck" alignItems="center">
      <Text color={opaque ? 'neutral.medium' : 'neutral.black'} variant="semibold">
        {label}
      </Text>
      {labelTooltip && <InfoTooltip tooltipText={labelTooltip} />}
    </HStack>
  );
};
